import { useFetchHubspot } from './useFetchHubspot'

const sendContactRequest = () => {
  const { sendContactRequest } = useFetchHubspot()

  return useMutation({
    mutationFn: sendContactRequest,
  })
}

const sendCancellation = () => {
  const { sendCancellation } = useFetchHubspot()

  return useMutation({
    mutationFn: sendCancellation,
  })
}

const sendTemplateRequest = () => {
  const { sendTemplateRequest } = useFetchHubspot()

  return useMutation({
    mutationFn: sendTemplateRequest,
  })
}

export const useMutationHubspot = {
  sendContactRequest,
  sendCancellation,
  sendTemplateRequest,
}
